import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://pxkgkchtijbswiideypt.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4a2drY2h0aWpic3dpaWRleXB0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyNDg4MzYsImV4cCI6MjA5MzgyNDgzNn0.2hJKCH1093dH5qSrGg019tAXakj2_-lF-vgGH6eimoA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export async function upsertMajorEvents(events, cleanType) {
  if (!events.length) return;
  const rows = events.filter(e => e.major && e.lat && e.lng).map(e => ({
    id: String(e.id),
    type: e._type,
    event_type: cleanType(e.type),
    location: e.location || null,
    division: e.division || null,
    lat: e.lat,
    lng: e.lng,
    alarm_level: e.alarmLevel || null,
    first_seen_at: e.time ? new Date(e.time).toISOString() : new Date().toISOString(),
    event_time: e.rawTime || (e.time ? new Date(e.time).toISOString() : null),
    source: e._type === "police" ? "tps" : "tfs",
  }));
  if (!rows.length) return;
  await supabase.from("major_events").upsert(rows, { onConflict: "id", ignoreDuplicates: true });
}

export async function fetchHistoricalMajors(days, division) {
  const since = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
  let query = supabase
    .from("major_events")
    .select("*")
    .gte("first_seen_at", since)
    .order("first_seen_at", { ascending: false })
    .limit(500);
  if (division !== "All") query = query.eq("division", division);
  const { data, error } = await query;
  if (error) throw error;
  return (data || []).map(r => ({
    id: r.id, _type: r.type, type: r.event_type,
    location: r.location, division: r.division,
    lat: r.lat, lng: r.lng, alarmLevel: r.alarm_level,
    time: new Date(r.first_seen_at).getTime(),
    rawTime: r.event_time, major: true, historical: true,
  }));
}
